import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'

interface NPaymentsState {
  deviceTypes: NameDto[]
  isLoading: boolean
}

const initialState: NPaymentsState = {
  deviceTypes: [],
  isLoading: false,
}

export const nPaymentsSlice = createSlice({
  name: 'nPayments',
  initialState,
  reducers: {
    fetchDeviceTypes: (state, action: PayloadAction<NameDto[]>) => {
      state.deviceTypes = action.payload
    },
  },
})
